import images from "./images";

const donations = [
    {
        id: 1,
        image: images.donation1,
        title: "Health Care Support",
        date: "8th March 2025",
        content: "Help us improve services by upgrading emergency vehicles for safety.",
        donation: {
            raised: 1000,
            goal: 2000
        },
        paragraphs: [
            "Support the upgrade of our emergency vehicles to ensure faster response and enhanced health care services for the community.",
            "Your generous donation will help us provide reliable transportation and timely medical aid during emergencies."
        ],
        gallery: [
            images.donation1Gallery1,
            images.donation1Gallery2
        ],
        objectives: [
            "Upgrade emergency vehicles for fast response.",
            "Improve emergency health care services.",
            "Ensure safe and reliable medical transportation.",
            "Reduce emergency response times.",
            "Support community health and safety."
        ],
        results: [
            "With your support, emergency vehicles will be upgraded, leading to faster responses and improved health care safety for our community."
        ]
    },
    {
        id: 2,
        image: images.donation2,
        title: "Donate School",
        date: "18th March 2025",
        content: "Support the development of schools to provide education for children.",
        donation: {
            raised: 2000,
            goal: 5000
        },
        paragraphs: [
            "Help us enhance educational resources and infrastructure to create a nurturing learning environment for students.",
            "Your contribution will directly impact the quality of education and opportunities for children in need."
        ],
        gallery: [
            images.donation2Gallery1,
            images.donation2Gallery2
        ],
        objectives: [
            "Improve school infrastructure and facilities.",
            "Provide learning materials and resources.",
            "Support teacher training and development.",
            "Increase access to quality education.",
            "Empower children through education."
        ],
        results: [
            "Donations will lead to better-equipped schools, improved learning experiences, and greater educational success for students."
        ]
    },
    {
        id: 3,
        image: images.donation3,
        title: "Shelter Homes",
        date: "28th April 2025",
        content: "Provide shelter for homeless individuals, ensuring their needs are met.",
        donation: {
            raised: 2500,
            goal: 10000
        },
        paragraphs: [
            "Your support will help build and maintain shelter homes, offering warmth, safety, and care to those in need.",
            "We aim to create a welcoming environment that promotes well-being and stability for vulnerable community members."
        ],
        gallery: [
            images.donation3Gallery1,
            images.donation3Gallery2
        ],
        objectives: [
            "Construct and maintain safe shelter homes.",
            "Provide essential services and support.",
            "Offer a stable and caring environment.",
            "Assist vulnerable individuals in crisis.",
            "Promote dignity and respect for all."
        ],
        results: [
            "Contributions will ensure shelter homes remain safe havens, improving quality of life for those facing homelessness and hardship."
        ]
    },
    {
        id: 4,
        image: images.donation4,
        title: "Save Children",
        date: "23rd April 2025",
        content: "Support programs that protect children, ensuring their health.",
        donation: {
            raised: 3000,
            goal: 4000
        },
        paragraphs: [
            "Your donation helps provide nutritious food, medical care, and educational resources to vulnerable children.",
            "Together, we can create a brighter future by safeguarding children’s rights and empowering them to thrive."
        ],
        gallery: [
            images.donation4Gallery1,
            images.donation4Gallery2
        ],
        objectives: [
            "Provide nutrition and healthcare for children.",
            "Support access to education and learning materials.",
            "Protect children from abuse and neglect.",
            "Promote child development and well-being.",
            "Empower children through community programs."
        ],
        results: [
            "With your support, children receive essential care and opportunities, paving the way for a healthier and happier generation."
        ]
    },
    {
        id: 5,
        image: images.donation5,
        title: "Feed People",
        date: "8th March 2025",
        content: "Help us provide meals to those in need, promoting health within our community.",
        donation: {
            raised: 1200,
            goal: 6000
        },
        paragraphs: [
            "Your generous contributions enable us to distribute food packages and hot meals to vulnerable families and individuals.",
            "Together, we can combat hunger and ensure that no one in our community goes without a proper meal."
        ],
        gallery: [
            images.donation5Gallery1,
            images.donation5Gallery2
        ],
        objectives: [
            "Provide regular meals to the hungry and homeless.",
            "Distribute food packages to families in need.",
            "Support community food banks and kitchens.",
            "Promote nutrition and food security.",
            "Raise awareness about hunger issues."
        ],
        results: [
            "Thanks to your donations, many individuals and families receive nourishing meals, improving their health and quality of life."
        ]
    },
    {
        id: 6,
        image: images.donation6,
        title: "Children Education",
        date: "8th March 2025",
        content: "Support educational programs to help children access learning opportunities.",
        donation: {
            raised: 1500,
            goal: 8000
        },
        paragraphs: [
            "Your donation helps fund school supplies, scholarships, and educational activities for underprivileged children.",
            "Together, we can empower the next generation with knowledge and skills for a brighter future."
        ],
        gallery: [
            images.donation6Gallery1,
            images.donation6Gallery2
        ],
        objectives: [
            "Provide school supplies and learning materials.",
            "Offer scholarships for deserving students.",
            "Organize after-school tutoring and support.",
            "Enhance educational infrastructure.",
            "Promote literacy and lifelong learning."
        ],
        results: [
            "With your support, children gain access to education, improving their chances for success and community development."
        ]
    }

];

export default donations;